<template>
    <div class="td-autocomplete form-item">
        <div v-if="!hideLabel">
            <label for="account" class="td-label mb-1">Account: </label>
        </div>
        <div :class="[!selectedAccount && searchTermAccount ? 'focused': '', 'autocomplete-input']">
            <div v-if="selectedAccount" class="td-selected-input">
                <span>
                    {{selectedAccount.display}}
                    <a href="#" v-if="!disable" class="input-deselect" @click.prevent="selectAccount()">
                        <icon type="solid" name="faXmark" aria-hidden="true"></icon>
                    </a>
                </span>
            </div>
            <input v-if="!selectedAccount" type="text"
                   placeholder="Enter account number or name"
                   name="account"
                   id="account"
                   @focus="showAccountList = true"
                   v-model="searchTermAccount"
                   @keyup.enter="selectAccount(accountList[0])" />
        </div>
        <div></div>
        <div :class="[!selectedAccount && showAccountList ? 'show-results' : 'hide-results', 'autocomplete-results']">
            <ul class="results-list" v-if="accountList.length > 0">
                <li v-for="(item, idx) in accountList" :key="idx">
                    <a @click.prevent="selectAccount(item)" href="#">{{item.display}}</a>
                </li>
            </ul>
            <ul class="results-list" v-else>
                <li class="td-text-subdued pa-1">
                    No accounts found
                </li>
            </ul>
        </div>
       
    </div>
</template>
<script>import script from './AccountLookup';
    export default script;</script>